import { Route } from 'react-router-dom';
import { ProtectedRoute } from './ProtectedRoute';
import { RegularLayout } from '../layout/RegularLayout';
import { ROUTES } from '../constants/FrontendPathConstants';
import JobsManagement from '../pages/SidePages/FoldersContainer';
import ProfilePage from '../pages/SidePages/ProfilePage';
import IntroductionPage from '../pages/SidePages/IntroductionPage';

import SamplePage from '../pages/Sample/SamplePage';

import SomaticMutation from '../pages/SidePages/SomaticMutation';
import PGXExtractor from '../pages/SidePages/PGXExtractor';
import BulkRNASeq from '../pages/SidePages/BulkRNASeq';
import HaplotypeCaller from '../pages/SidePages/HaplotypeCaller';
import DeepVariant from '../pages/SidePages/DeepVariant';
import HLATyping from '../pages/SidePages/HLATyping';
import VCF2TXT from '../pages/SidePages/VCF2TXT';
import Mutect2 from '../pages/SidePages/Mutect2';
import SomaticVariant from '../pages/SidePages/SomaticVariant';
import ChIPSeq from '../pages/SidePages/ChIPSeq';
import SCRNASeq from '../pages/SidePages/TSCRNASeq';
import ATACSeq from '../pages/SidePages/ATACSeq';
import BisulfiteSeq from '../pages/SidePages/BisulfiteSeq';


import { Navigate } from 'react-router-dom';


export const privateRoutes = (
  <>
    {/* Default after login: Shows Sidebar with IntroductionPage */}
    <Route path="/" element={<Navigate to={ROUTES.INTRODUCTION} replace />} />

    <Route
      path={ROUTES.INTRODUCTION}
      element={
        <ProtectedRoute>
          <RegularLayout>
            <IntroductionPage />
          </RegularLayout>
        </ProtectedRoute>
      }
    />

    {/* Job Details Page */}
    <Route
      path="/jobs/:projectId/samples"
      element={
        <ProtectedRoute>
          <RegularLayout>
            <SamplePage />
          </RegularLayout>
        </ProtectedRoute>
      }
    />

    {/* Somatic Mutation */}
    <Route
      path="/somatic-mutation"
      element={
        <ProtectedRoute>
          <RegularLayout>
            <SomaticMutation />
          </RegularLayout>
        </ProtectedRoute>
      }
    />

    {/* PGX Extractor - PROPEX */}
    <Route
      path="/pgx-extractor"
      element={
        <ProtectedRoute>
          <RegularLayout>
            <PGXExtractor />
          </RegularLayout>
        </ProtectedRoute>
      }
    />

    {/* HLA Typing */}
    <Route
      path="/hla-typing"
      element={
        <ProtectedRoute>
          <RegularLayout>
            <HLATyping />
          </RegularLayout>
        </ProtectedRoute>
      }
    />

    {/* VCF2TXT Converter */}
    <Route
      path="/vcf2txt"
      element={
        <ProtectedRoute>
          <RegularLayout>
            <VCF2TXT />
          </RegularLayout>
        </ProtectedRoute>
      }
    />

    {/* Haplotype Caller */}
    <Route
      path="/germline-mutation/haplotype-caller"
      element={
        <ProtectedRoute>
          <RegularLayout>
            <HaplotypeCaller />
          </RegularLayout>
        </ProtectedRoute>
      }
    />

    {/* Deep Variant */}
    <Route
      path="/germline-mutation/deep-variant"
      element={
        <ProtectedRoute>
          <RegularLayout>
            <DeepVariant />
          </RegularLayout>
        </ProtectedRoute>
      }
    />

    {/* Mutect2 */}
    <Route
      path="/somatic-mutation/mutect-2"
      element={
        <ProtectedRoute>
          <RegularLayout>
            <Mutect2 />
          </RegularLayout>
        </ProtectedRoute>
      }
    />

    {/* SomaticVariant */}
    <Route
      path="/somatic-mutation/somatic-variant"
      element={
        <ProtectedRoute>
          <RegularLayout>
            <SomaticVariant />
          </RegularLayout>
        </ProtectedRoute>
      }
    />

    {/* Bulk-RNA-Seq */}
    <Route
      path="/bulk-rna-seq"
      element={
        <ProtectedRoute>
          <RegularLayout>
            <BulkRNASeq />
          </RegularLayout>
        </ProtectedRoute>
      }
    />

    {/* scRNA-Seq */}
    <Route
      path="/scrna-seq"
      element={
        <ProtectedRoute>
          <RegularLayout>
            <SCRNASeq />
          </RegularLayout>
        </ProtectedRoute>
      }
    />

    {/* ChIP-Seq */}
    <Route
      path="/chip-seq"
      element={
        <ProtectedRoute>
          <RegularLayout>
            <ChIPSeq />
          </RegularLayout>
        </ProtectedRoute>
      }
    />

    {/* ATAC-Seq */}
    <Route
      path="/atac-seq"
      element={
        <ProtectedRoute>
          <RegularLayout>
            <ATACSeq />
          </RegularLayout>
        </ProtectedRoute>
      }
    />

    {/* Bisulfite-Seq */}
    <Route
      path="/bisulfite-seq"
      element={
        <ProtectedRoute>
          <RegularLayout>
            <BisulfiteSeq />
          </RegularLayout>
        </ProtectedRoute>
      }
    />

    {/* Profile Page */}
    <Route
      path={ROUTES.PROFILE}
      element={
        <ProtectedRoute>
          <RegularLayout>
            <ProfilePage />
          </RegularLayout>
        </ProtectedRoute>
      }
    >
      {/* */}
      <Route path="jobs" element={<JobsManagement />} />
    </Route>


  </>
);
